import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid'
import { Field, change, reduxForm, submit } from 'redux-form'
import * as d3 from 'd3'

import './JDISettingsModal.css';

import Button from '../../components/Button/Button.js'
import Tabs from '../../components/Tabs/Tabs.js'
import Checkbox from '../../components/Checkbox/Checkbox.js'

import deepDefaults from '../../pattern_utilities/deepDefaults'

import { setJDISettingsModalOpen, pmUpdateFromHybrid, showTooltip, hideTooltip } from '../../actions/actions.export.js';

class JDISettingsModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = props.initialValues;

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleCloseModal(){
    const { dispatch } = this.props;

    dispatch(setJDISettingsModalOpen());
  }

  handleSave(values){
    const { dispatch, patternManager } = this.props;  

    // console.log(values);

    var updated_data = {};
    updated_data.jdiSettings = this.state;

    let numeric_string_list = ['canvas_width', 'canvas_height', 'grid_snap_size', 'polygon_facets', 'polygon_rotation'];
    for(let i in numeric_string_list){
      updated_data.jdiSettings[numeric_string_list[i]] = parseFloat(updated_data.jdiSettings[numeric_string_list[i]])
    }

    if(!updated_data.jdiSettings.canvas_width || updated_data.jdiSettings.canvas_width < .125) updated_data.jdiSettings.canvas_width = .125;
    if(!updated_data.jdiSettings.canvas_height || updated_data.jdiSettings.canvas_height < .125) updated_data.jdiSettings.canvas_height = .125;

    if(!updated_data.jdiSettings.canvas_width) updated_data.jdiSettings.canvas_width = .125;
    if(!updated_data.jdiSettings.canvas_height) updated_data.jdiSettings.canvas_height = .125;

    if(!updated_data.jdiSettings.polygon_facets) updated_data.jdiSettings.polygon_facets = 3;
    if(updated_data.jdiSettings.polygon_facets > 32) updated_data.jdiSettings.polygon_facets = 32;

    dispatch(pmUpdateFromHybrid({
      cacheID: patternManager.current_pattern,
      pattern: updated_data,
      forceRedraw: true
    }))
  }

  componentDidMount(){
    this.setState({
      last_polygon_facets: false,
      last_polygon_rotation: false
    })
  }


  componentDidUpdate(){

    let polygon_facets = parseInt(this.state.polygon_facets);
    if(polygon_facets === "" || polygon_facets < 3 || ! polygon_facets) polygon_facets = 3;

    if(polygon_facets !== this.state.last_polygon_facets || this.state.polygon_rotation !== this.state.last_polygon_rotation){

      let el = document.getElementById('jdi-circle-preview-svg');
      if(!el) return;
      let positionInfo = el.getBoundingClientRect();
      let width = positionInfo.width;
      let height = positionInfo.height;



      var svg = d3.select('#jdi-circle-preview-svg')
        .attr('width', width)
        .attr('height', height)
        ;

      // we tuck this in a G so we can easily clear it
      svg.selectAll('g').remove();
      svg = svg.append('g');

      let r = width > height ? height * .33 : width * .33;

      for(let i = 0; i < Math.PI * 2; i += Math.PI * 2 / polygon_facets){
        let ti = i - Math.PI / 2 - (Math.PI * this.state.polygon_rotation/180);
        let tj = ti + (Math.PI * 2 / polygon_facets);

        svg.append('line')
          .attr('x1', r * Math.cos(ti) + width / 2)
          .attr('y1', r * Math.sin(ti) + height / 2)
          .attr('x2', r * Math.cos(tj) + width / 2)
          .attr('y2', r * Math.sin(tj) + height / 2)
          .attr('stroke', '#000')
          .attr('stroke-width', 2)
          ;
      }

      this.setState({
        last_polygon_facets: polygon_facets,
        last_polygon_rotation: this.state.polygon_rotation
      })
    }
  }


  render(){
    const { dispatch, user, team, patternManager } = this.props; 
    
    // if(!globalReducer.jdiSettingsModalOpen) return "";


    var pattern = patternManager.cache[patternManager.current_pattern];

    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModal}>
      </div>
      <form name="JDISettingsModal" className="modal-inner" onSubmit={this.handleSave}>
        <div className="flex-split">
          <span>
            Drawing Canvas Settings
          </span>
          <span>
            <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModal}/> 
          </span>
        </div>
        <hr/>
        <div className="jdi-settings-modal">
          <div className="jdi-settings-modal-info">
            <p><strong>General</strong></p>
            <div className="jdi-settings-modal-nontable">
              <div className="flex-split">
                <span>
                  Canvas Width:
                </span>
                <span className="text-right">
                  <Field 
                    name="canvas_width" 
                    component="input" 
                    type="number" 
                    min={0}
                    normalize={(v) => {
                      if(v !== ""){
                        if(pattern.units === "INCH"){
                          if(v > 120) v = 120;
                          if(v < 0) v = 0;
                        } else if(pattern.units === "MM"){
                          v = parseInt(v);
                          if(v > 4000) v = 4000;
                          if(v < 1) v = 1;
                        }
                      }
                      return v;
                    }}
                    onChange={(e, newValue) => { 
                      this.setState({canvas_width: newValue}) 
                    }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Canvas Height:
                </span>
                <span className="text-right">
                  <Field 
                    name="canvas_height" 
                    component="input" 
                    type="number" 
                    min={0}
                    normalize={(v) => {
                      if(v !== ""){
                        if(pattern.units === "INCH"){
                          if(v > 120) v = 120;
                          if(v < 0) v = 0;
                        } else if(pattern.units === "MM"){
                          v = parseInt(v);
                          if(v > 4000) v = 4000;
                          if(v < 1) v = 1;
                        }
                      }
                      return v;
                    }}
                    onChange={(e, newValue) => { this.setState({canvas_height: newValue}) }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Auto Fix:&nbsp;&nbsp;  
                  <span
                  className="has-tooltip"
                  onMouseEnter={(e)=>{ 
                    dispatch(showTooltip({
                      e: e,
                      position: 'left', 
                      lag: 100,
                      nobr: false,
                      content: <div style={{width: 200}}>
                        Auto Fix will attempt to shift lines to avoid errors caused by Revit & AutoCAD import limitations. If any lines cannot be converted to fit within these limitations, a warning will be shown.
                      </div>
                    }))
                  }} 
                  onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                  >
                  <i className="fal fa-question-circle text-grey-primary"/>
                </span>
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox switch={true} value={this.state.autofix} onToggle={(e)=>{ this.setState({autofix: !this.state.autofix })}}/>
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Orthographic:
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox switch={true} value={this.state.ortho} onToggle={(e)=>{ this.setState({ortho: !this.state.ortho })}}/>
                </span>
              </div>
            </div>
          </div>

          <div className="jdi-settings-modal-info">
            <p><strong>Line Snap</strong></p>
            <div className="jdi-settings-modal-nontable">
              <div className="flex-split">
                <strong>
                  On / Off:
                </strong>
                <span className="download-modal-data td-checkbox">
                  <Checkbox switch={true} value={this.state.line_snap_global} onToggle={(e)=>{ this.setState({line_snap_global: !this.state.line_snap_global })}}/>
                </span>
              </div>

              <div className="flex-split">
                <span className={this.state.line_snap_global ? "" : "translucent"}>
                  Endpoints:
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox disabled={!this.state.line_snap_global} value={this.state.line_snap_endpoints} onToggle={(e)=>{ this.setState({line_snap_endpoints: !this.state.line_snap_endpoints })}}/>
                </span>
              </div>

              <div className="flex-split">
                <span className={this.state.line_snap_global ? "" : "translucent"}>
                  Midpoints:
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox disabled={!this.state.line_snap_global} value={this.state.line_snap_midpoints} onToggle={(e)=>{ this.setState({line_snap_midpoints: !this.state.line_snap_midpoints })}}/>
                </span>
              </div>

              <div className="flex-split">
                <span className={this.state.line_snap_global ? "" : "translucent"}>
                  Intersections:
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox disabled={!this.state.line_snap_global} value={this.state.line_snap_intersections} onToggle={(e)=>{ this.setState({line_snap_intersections: !this.state.line_snap_intersections })}}/>
                </span>
              </div>

              <div className="flex-split">
                <span className={this.state.line_snap_global ? "" : "translucent"}>
                  Aligned:
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox disabled={!this.state.line_snap_global} value={this.state.line_snap_aligned} onToggle={(e)=>{ this.setState({line_snap_aligned: !this.state.line_snap_aligned })}}/>
                </span>
              </div>
            </div>
            <hr/>
            <p><strong>Grid Snap</strong></p>
            <div className="jdi-settings-modal-nontable">
              <div className="flex-split">
                <strong>
                  On / Off:
                </strong>
                <span className="download-modal-data td-checkbox">
                  <Checkbox switch={true} value={this.state.grid_snap_global} onToggle={(e)=>{ this.setState({grid_snap_global: !this.state.grid_snap_global })}}/>
                </span>
              </div>

              <div className="flex-split">
                <span className={this.state.grid_snap_global ? "" : "translucent"}>
                  Grid Size:
                </span>
                <span className="text-right">
                  <Field 
                    name="grid_snap_size" 
                    component="input" 
                    type="number" 
                    min={0}
                    normalize={(v) => {
                      if(v !== ""){
                        if(v < 0) v = 0;
                        let mindim = Math.min(this.state.canvas_width, this.state.canvas_height);
                        if(v > mindim / 2) v = mindim / 2;
                      }
                      return v;
                    }}
                    disabled={!this.state.grid_snap_global}
                    onChange={(e, newValue) => { this.setState({grid_snap_size: newValue}) }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span className={this.state.grid_snap_global ? "" : "translucent"}>
                  Show grid lines:
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox disabled={!this.state.grid_snap_global} value={this.state.grid_snap_show} onToggle={(e)=>{ this.setState({grid_snap_show: !this.state.grid_snap_show })}}/>
                </span>
              </div>
            </div>
          </div>

          <div className="jdi-settings-modal-info">
            <p><strong>Polygon</strong></p>
            <div className="jdi-settings-modal-nontable">
              <div className="flex-split">
                <span>
                  Facets:
                </span>
                <span className="text-right">
                  <Field 
                    name="polygon_facets" 
                    component="input" 
                    type="number" 
                    min="3"
                    max="32"
                    normalize={(v) => {
                      if(v !== ""){
                        if(v > 32) v = 32;
                      }
                      return v;
                    }}
                    onChange={(e, newValue) => { 
                      this.setState({polygon_facets: newValue}) 
                    }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Init. Rotation:
                </span>
                <span className="text-right">
                  <Field 
                    name="polygon_rotation" 
                    component="input" 
                    type="number" 
                    min="0"
                    max="360"
                    normalize={(v) => {
                      if(v !== ""){
                        if(v < 0) v = 0;
                        if(v > 360) v = 360;
                      }
                      return v;
                    }}
                    onChange={(e, newValue) => { this.setState({polygon_rotation: newValue}) }}
                    />
                </span>
              </div>

              <div className="jdi-facets-preview">
                <small className="">Preview:</small>
                <svg id="jdi-circle-preview-svg"/>
              </div>
            </div>
          </div>
        </div>
        <div className="list-right">
          <div className="list-item">
            <Button
              display="Cancel"
              color="grey"
              size="medium"
              onClick={(e)=>{
                dispatch(setJDISettingsModalOpen(false));
              }}
              />
          </div>
          <div className="list-item">
            <Button
              display="Save"
              
              color="success"
              size="medium"
              onClick={(e)=>{
                // process changes
                this.handleSave();
                dispatch(setJDISettingsModalOpen(false));
              }}
              />
          </div>
        </div>
      </form>
    </div>
  }
}

JDISettingsModal = reduxForm({
  // a unique name for the form
  form: 'JDISettingsModal',
  enableReinitialize: true,
  destroyOnUnmount: false
})(JDISettingsModal)


JDISettingsModal = connect((state, ownProps) => {
  const { patternManager } = state;

  const defaultSettings = {
    autofix: true,
    canvas_width: 12,
    canvas_height: 12,
    ortho: true,

    grid_snap_global: true,
    grid_snap_size: .125,
    grid_snap_show: true,

    line_snap_global: true,
    line_snap_endpoints: true,
    line_snap_midpoints: true,
    line_snap_intersections: true,
    line_snap_aligned: true,

    polygon_facets: 20,
    polygon_rotation: 0
  }

  let pat = patternManager.cache[patternManager.current_pattern];
  let initialValues = {}
  if(pat){
    // console.log(pat.jdiSettings, pat);
    initialValues = pat.jdiSettings;
  }

  initialValues = deepDefaults(initialValues, defaultSettings);

  return {
    patternManager,
    initialValues,
    state
  }
})(JDISettingsModal);


export default JDISettingsModal;



// WEBPACK FOOTER //
// ./src/components/JDISettingsModal/JDISettingsModal.js